module.exports = __webpack_public_path__ + "static/3-942a0e760d0503aed256fbd631915130.jpg";